import React from "react";

import { MenuItem } from "App/common/Menu";
import { Select } from "App/common/Select";
import { SORT_TYPE } from "App/routes/Main/Library/config";
import styles from "./EntitySortMenu.module.scss";

export const EntitySortMenu = ({
  sortType = SORT_TYPE.CUSTOM,
  onChange,
}: {
  sortType: SORT_TYPE;
  onChange: (sortType: SORT_TYPE) => void;
}) => {
  return (
    <span className={styles["highnote-entity-sort-select"]}>
      <Select
        MenuProps={{
          className: "highnote-sort-menu",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }}
        value={sortType}
        size="xs"
        variant="solid"
        color="secondary"
        onChange={(e) => onChange(e.target.value as SORT_TYPE)}
      >
        {[SORT_TYPE.ALPHABETICAL, SORT_TYPE.CREATED_AT, SORT_TYPE.CUSTOM].map(
          (type) => {
            return (
              <MenuItem key={`sort-${type}`} value={type}>
                <span className="title">{type}</span>
              </MenuItem>
            );
          },
        )}
      </Select>
    </span>
  );
};
